import curryRight from 'lodash/fp/curryRight'
import isEmpty from 'lodash/fp/isEmpty'
import complement from 'lodash/fp/complement'

/**
 * check if variable is not empty
 *
 * @param {any} value - value to check
 * @return {Boolean} true if is filled
 */
export const isFilled = complement(isEmpty)

/**
 * if is not empty value return value else default value
 *
 * @param {any} value - value to return if is not empty
 * @param {any} defaultValue - value to return if is empty
 * @return {any} value or default value
 */
export const ifNotEmpty = curryRight(
  (value, defaultValue) => isFilled(value) ? value : defaultValue
)
